import Resource from '@/services/resources/common';
import router from '@/services/router';
import security from '@/services/security';

export default class QuestionPatternResource extends Resource {
  constructor(entrypoint = '/question_patterns', alias = 'QuestionPattern') {
    super(entrypoint, alias);
  }

  canUpdate() {
    const isTranslator =
      !security.isGranted('ROLE_SUPER_ADMIN') &&
      !security.isGranted('ROLE_ADMIN') &&
      security.isGranted('ROLE_TRAD_DIAGNOSTIC');
    const permission = isTranslator ? 'translator:update' : 'update';

    return security.hasPermissions({ [this.alias]: [permission] });
  }

  update(...args) {
    const isTranslator =
      !security.isGranted('ROLE_SUPER_ADMIN') &&
      !security.isGranted('ROLE_ADMIN') &&
      security.isGranted('ROLE_TRAD_DIAGNOSTIC');
    this.entrypoint = isTranslator ? '/translator/question_patterns' : this.entrypoint;

    return super.update(...args);
  }

  navigateToList() {
    if (
      !security.isGranted('ROLE_SUPER_ADMIN') &&
      !security.isGranted('ROLE_ADMIN') &&
      security.isGranted('ROLE_TRAD_DIAGNOSTIC')
    ) {
      router.navigate('translator_question_patterns_list');
      return true;
    }

    return false;
  }
}
